package uz.ferro.erp.feature.text.model

enum class DocItemType {
    LIST,
    TEXT,
    FORMATTED_TEXT,
    LINK,
    IMAGE
}